"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.export.csv': 'Eksportuj CSV',
    'reports.export.excel': 'Eksportuj Excel',
};
